import React, { Fragment } from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { t } from 'Src/i18n';
import { AlternativeSuggestionCriteria } from 'Components/widgets/alternative-proposals/alternative-duration-suggestions/AlternativeSuggestionCriteria';
import { AlternativeSuggestions } from 'Components/widgets/alternative-proposals/alternative-suggestions/AlternativeSuggestions';
type Props = {
  durations: ReadonlyArray<DurationSuggestions>;
  onSelectNewDuration: (arg0: { proposalIds: ReadonlyArray<string>; duration: number }) => void;
  trackingData: (arg0: string) => void;
};
export const AlternativeDurationSuggestions = ({
  durations,
  onSelectNewDuration,
  trackingData,
}: Props) => (
  <AlternativeSuggestions title={t('booking.counterProposalPopIn.durationsLabel')}>
    {durations.map((suggestion) => {
      const { duration } = suggestion.data;
      const multi = durations.length > 1;
      return (
        <AlternativeSuggestionCriteria
          buttonLabel={t('booking.counterProposalPopIn.checkPriceLabelDuration')}
          className={classnames({
            'last:scroll-x-ghost-m-20 last:scroll-x-ghost-m w-280 flex-none sm:w-auto': multi,
            'flex-1': !multi,
          })}
          key={duration}
          onSubmit={() => {
            onSelectNewDuration({
              proposalIds: suggestion.ids,
              duration,
            });
            trackingData('duration_check');
          }}
          suggestion={{
            ...suggestion.data,
            price: {
              total: suggestion.data.price.total.formattedValue,
            },
          }}
          title={
            <Fragment>
              {t('booking.counterProposalPopIn.durationLabel')}{' '}
              <span className="text-18 font-bold text-sienna">
                {t('booking.counterProposalPopIn.durationsSuggestions', {
                  duration,
                })}
              </span>
            </Fragment>
          }
        />
      );
    })}
  </AlternativeSuggestions>
);
